import styled from "styled-components";
import { APP_STORE_URL } from "../constants/links";
import { FillImage } from "./FillImage";

type StoreBadgesProps = {
  size?: "default" | "large";
};

export function StoreBadges({ size = "default" }: StoreBadgesProps) {
  const iosHeight = size === "large" ? 60 : 55;

  return (
    <Badges>
      <Badge height={iosHeight} href={APP_STORE_URL} target="_blank" rel="noopener">
        <FillImage
          src="/ios-badge.svg"
          alt="Download on the App Store"
          $fit="contain"
        />
      </Badge>
    </Badges>
  );
}

const Badges = styled.div({
  display: "flex",
  gap: 12,
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  paddingLeft: 8,
});

const Badge = styled.a<{ height: number }>(({ height }) => ({
  height,
  width: 220,
  display: "block",
  position: "relative",
  transition: "transform 0.2s ease, opacity 0.2s ease",

  "&:hover": {
    transform: "translateY(-2px)",
    opacity: 0.9,
  },
}));
